export default __webpack_public_path__ + "static/media/hamburger.0d10317e.svg";